import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addShortPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  DEFAULT_STOCK_POSITION,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const cashSecuredPut: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strike,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  // Use the default expiration date function to get the expiration date
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Choose a strike price slightly below the current spot price
  const strikePrice = strike
    ? strike
    : findClosestStrikePrice(strikesAtExpiration, getStrikeDistance({ price: spot, unit: 0 }));

  if (strikePrice === -1) {
    return EMPTY_STRATEGY;
  }

  // Build the option position
  const optionPosition = addShortPut({
    strike: strikePrice,
    premium: getPremium({
      ask: strikesAtExpiration?.c?.[strikePrice]?.p?.a || 0,
      bid: strikesAtExpiration?.c?.[strikePrice]?.p?.b || 0,
      strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
    }),
    expirationDate: expirationDateForOptions,
    expirationKey: expirationKeyForOptions,
    numberOfContracts: 1 * contractMultiplier,
  });

  // Cash position to secure the put - Cash equivalent to 100 shares at the strike price
  const cashPosition = {
    amount: strikePrice * DEFAULT_STOCK_POSITION,
  };

  return {
    optionPositions: [optionPosition],
    cashPositions: [cashPosition], // Includes cash position instead of stock
    stockPositions: [], // No stock position
  };
};
